(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["essentials-collection"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  document.querySelectorAll('.ec-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.ec-faq__question').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var otherAnswer = document.getElementById(other.getAttribute('aria-controls'));
          if (otherAnswer) otherAnswer.hidden = true;
        }
      });

      btn.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.hidden = expanded;
    });
  });

  document.querySelectorAll('.ec-reviews3d').forEach(function (root) {
    var vp = root.querySelector('.ec-reviews3d__viewport');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ec-reviews3d__card'));
    var prevBtn = root.querySelector('.ec-reviews3d__btn--prev');
    var nextBtn = root.querySelector('.ec-reviews3d__btn--next');
    var n = cards.length;

    if (!vp || !n) return;

    var angle = parseFloat(vp.getAttribute('data-angle')) || 34;
    var spacingPct = (parseFloat(vp.getAttribute('data-spacing')) || 58) / 100;
    var maxVisible = parseInt(vp.getAttribute('data-neighbors'), 10) || 2;
    var autoplay = vp.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(vp.getAttribute('data-speed'), 10) || 5000;
    var active = n > 2 ? Math.floor(n / 2) : 0;
    var timer = null;
    var inView = !('IntersectionObserver' in window);

    function layout() {
      var cardW = cards[0].offsetWidth || 300;
      var small = window.innerWidth < 750;
      var step = cardW * (small ? Math.max(0.42, spacingPct - 0.15) : spacingPct);
      var ang = small ? Math.min(angle, 24) : angle;

      cards.forEach(function (card, i) {
        var d = i - active;
        var ad = Math.abs(d);
        var hidden = ad > maxVisible;
        var tx = d * step;
        var ry = d === 0 ? 0 : (d < 0 ? ang : -ang);
        var sc = d === 0 ? 1 : Math.max(0.66, 0.86 - (ad - 1) * 0.08);
        var tz = d === 0 ? 0 : -ad * 60;

        card.style.transform = 'translate(calc(-50% + ' + tx + 'px), -50%) rotateY(' + ry + 'deg) translateZ(' + tz + 'px) scale(' + sc + ')';
        card.style.zIndex = String(100 - ad);
        card.style.opacity = hidden ? '0' : '1';
        card.style.pointerEvents = hidden ? 'none' : 'auto';
        card.classList.toggle('is-active', d === 0);
      });

      if (prevBtn) prevBtn.disabled = active === 0;
      if (nextBtn) nextBtn.disabled = active === n - 1;
    }

    function goTo(i) {
      active = Math.max(0, Math.min(n - 1, i));
      layout();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || n <= 1 || !inView || document.hidden) return;
      stop();
      timer = setInterval(function () {
        goTo(active >= n - 1 ? 0 : active + 1);
      }, speed);
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (i !== active) {
          goTo(i);
          start();
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(active - 1);
        start();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(active + 1);
        start();
      });
    }

    var startX = 0;

    vp.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });

    vp.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) {
        goTo(dx < 0 ? active + 1 : active - 1);
      }
      start();
    }, { passive: true });

    vp.addEventListener('mouseenter', stop);
    vp.addEventListener('mouseleave', start);

    var resizeRaf = 0;
    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(function () {
        resizeRaf = 0;
        layout();
      });
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var reviewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          inView = entry.isIntersecting;
          if (inView) start();
          else stop();
        });
      }, { rootMargin: '180px 0px', threshold: 0.01 });
      reviewObserver.observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    layout();
    if (inView) start();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-collection"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  /* ============================================================
     SCROLL STORY  (NEW)
     ------------------------------------------------------------
     One rAF-throttled scroll handler per story section computes:
       - progress (0..1) of the pinned scroller -> drives bar
       - active slide index -> toggles `.is-active` (cross-fade)
     Dots are clickable (scroll to that slide). Reduced-motion users
     get the CSS fallback and we skip the JS entirely.
     ============================================================ */
  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStory(root) {
    var scroller = root.querySelector('[data-lx-story-scroller]');
    var slides   = Array.prototype.slice.call(root.querySelectorAll('[data-lx-slide]'));
    var dots     = Array.prototype.slice.call(root.querySelectorAll('[data-lx-dot]'));
    var fill     = root.querySelector('[data-lx-story-progress]');
    var n = slides.length;
    if (!scroller || !n) return;

    var current = -1;
    var ticking = false;
    var storyNearby = true;

    if ('IntersectionObserver' in window) {
      var storyIO = new IntersectionObserver(function (entries) {
        storyNearby = !!(entries[0] && entries[0].isIntersecting);
        if (storyNearby) onScroll();
      }, { rootMargin: '100% 0px 100% 0px' });
      storyIO.observe(root);
    }

    // Mark which slide owns the visible copy.
    // idx = -1 intentionally hides ALL copy while a slide is moving, matching
    // the reference: first the image finishes settling, then the text animates in.
    function setActive(idx, dotIdx) {
      if (idx === current) {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === dotIdx); });
        return;
      }
      current = idx;
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === dotIdx); });
    }

    function update() {
      ticking = false;
      var rect = scroller.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = scroller.offsetHeight - vh;            // total scroll distance
      if (total <= 0) {
        // Not enough room to pin: show all stacked, first active.
        slides.forEach(function (s) { s.style.clipPath = 'none'; });
        setActive(0, 0);
        if (fill) fill.style.height = '0%';
        return;
      }

      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var progress = scrolled / total;                  // 0..1 across all slides

      // Position on a 0..(n-1) timeline.
      // Each slide band now has three parts: hold copy -> move image -> reveal copy.
      // This prevents premature text on the final/next section.
      var pos = progress * (n - 1);
      var base = Math.min(n - 1, Math.floor(pos + 1e-6));
      var frac = pos - base;                            // 0..1 inside the current band
      var transitionStart = 0.14;                       // copy starts fading out here
      var transitionEnd   = 0.86;                       // incoming slide is settled here
      var revealFrac = 0;

      if (base < n - 1) {
        revealFrac = (frac - transitionStart) / (transitionEnd - transitionStart);
        revealFrac = Math.min(Math.max(revealFrac, 0), 1);
      } else {
        revealFrac = 1;
      }

      // Drive each slide's clip-path: the next slide only starts moving after
      // the current copy has faded out, and it is fully positioned BEFORE
      // the next copy animates in.
      slides.forEach(function (s, i) {
        if (i <= base) {
          s.style.clipPath = 'inset(0 0 0 0)';
          s.style.zIndex = String(10 + i);
        } else if (i === base + 1) {
          var hidden = (1 - revealFrac) * 100;
          s.style.clipPath = 'inset(' + hidden.toFixed(2) + '% 0 0 0)';
          s.style.zIndex = String(10 + i);
        } else {
          s.style.clipPath = 'inset(100% 0 0 0)';
          s.style.zIndex = String(10 + i);
        }
      });

      // Copy timing:
      // - stable at the start of each slide band
      // - hidden during the slide movement
      // - incoming copy appears only after the incoming slide is settled
      var activeIdx = base;
      var dotIdx = base;
      if (base < n - 1) {
        if (frac <= transitionStart) {
          activeIdx = base;
          dotIdx = base;
        } else if (frac >= transitionEnd) {
          activeIdx = base + 1;
          dotIdx = base + 1;
        } else {
          activeIdx = -1;
          dotIdx = base + (revealFrac >= 0.5 ? 1 : 0);
        }
      } else {
        activeIdx = n - 1;
        dotIdx = n - 1;
      }
      setActive(activeIdx, dotIdx);

      // Horizontal rail line: synchronized to the same band/active slide logic.
      slides.forEach(function (s, i) {
        var rf = s.querySelector('[data-lx-rail-fill]');
        if (!rf) return;
        var pct = 0;
        if (i < base) pct = 100;
        else if (i === base) pct = frac * 100;
        else if (i === base + 1 && frac >= transitionEnd) pct = 0;
        if (i === n - 1 && base >= n - 1) pct = 100;
        rf.style.width = pct.toFixed(2) + '%';
      });

      // Keep the side progress bar in sync with overall scroll.
      if (fill) fill.style.height = (progress * 100).toFixed(2) + '%';
    }

    function onScroll() {
      if (!storyNearby) return;
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    // Dot click -> scroll so that slide is fully revealed and centered in its band.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var total = scroller.offsetHeight - vh;
        var band = total / (n - 1 || 1);
        var target = scroller.offsetTop + (band * i) + (i > 0 && i < n - 1 ? band * 0.04 : 0);
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  document.querySelectorAll('[data-lx-story]').forEach(function (root) {
    if (prefersReduced) return; // CSS fallback handles the stacked view
    initStory(root);
  });

  /* Products are intentionally server-rendered with a six-item limit. */

  /* FAQ Accordion */
  document.querySelectorAll('.lx-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.lx-faq__question').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var oa = document.getElementById(other.getAttribute('aria-controls'));
          if (oa) oa.hidden = true;
        }
      });
      btn.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.hidden = expanded;
    });
  });

  /* Crystal Story Videos — autoplay on view (muted) + play/pause + sound toggle */
  document.querySelectorAll('.lx-vid-card').forEach(function (card) {
    var v = card.querySelector('.js-lx-autovideo');
    if (!v) return;

    // user intent: did the visitor manually pause this one?
    card._userPaused = false;

    function reflect() {
      var playing = !v.paused && !v.ended;
      card.classList.toggle('is-playing', playing);
      card.classList.toggle('is-paused', !playing);
    }
    v.addEventListener('play', reflect);
    v.addEventListener('pause', reflect);
    reflect();

    // Play/Pause button
    var pp = card.querySelector('.js-lx-playpause');
    if (pp) {
      pp.addEventListener('click', function () {
        if (v.paused) {
          card._userPaused = false;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          card._userPaused = true;
          v.pause();
        }
      });
    }

    // Sound toggle
    var sb = card.querySelector('.js-lx-sound');
    if (sb) {
      sb.addEventListener('click', function () {
        v.muted = !v.muted;
        card.classList.toggle('is-unmuted', !v.muted);
        if (!v.muted && v.paused) {
          card._userPaused = false;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    }
  });

  // Autoplay muted on view; never override a manual pause
  var autoCards = Array.prototype.slice.call(document.querySelectorAll('.lx-vid-card'))
    .filter(function (c) { return c.querySelector('.js-lx-autovideo'); });

  if (autoCards.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var v = card.querySelector('.js-lx-autovideo');
          if (!v) return;
          if (entry.isIntersecting) {
            if (!card._userPaused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.5 });
      autoCards.forEach(function (c) { io.observe(c); });
    } else {
      autoCards.forEach(function (c) {
        var v = c.querySelector('.js-lx-autovideo');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    }
  }

  /* Mobile slider dots sync */
  document.querySelectorAll('.js-lx-vslider').forEach(function (slider) {
    var track = slider.querySelector('.js-lx-vtrack');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('.lx-vids__dot'));
    if (!track || !dots.length) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.lx-vid-card'));

    function currentIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      cards.forEach(function (card, i) {
        var c = card.offsetLeft + card.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function setActive(i) {
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        setActive(currentIndex());
      });
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
      });
    });

    setActive(0);
  });

  /* 3D Testimonials coverflow */
  document.querySelectorAll('.lx-reviews3d').forEach(function (root) {
    var vp = root.querySelector('.lx-reviews3d__viewport');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.lx-reviews3d__card'));
    var prevBtn = root.querySelector('.lx-reviews3d__btn--prev');
    var nextBtn = root.querySelector('.lx-reviews3d__btn--next');
    var n = cards.length;
    if (!vp || !n) return;

    var angle = parseFloat(vp.getAttribute('data-angle')) || 34;
    var spacingPct = (parseFloat(vp.getAttribute('data-spacing')) || 58) / 100;
    var maxVisible = parseInt(vp.getAttribute('data-neighbors'), 10) || 2;
    var autoplay = vp.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(vp.getAttribute('data-speed'), 10) || 5000;
    var active = n > 2 ? Math.floor(n / 2) : 0;
    var timer = null;

    function layout() {
      var cardW = cards[0].offsetWidth || 300;
      var small = window.innerWidth < 750;
      var step = cardW * (small ? Math.max(0.42, spacingPct - 0.15) : spacingPct);
      var ang = small ? Math.min(angle, 24) : angle;

      cards.forEach(function (card, i) {
        var d = i - active;
        var ad = Math.abs(d);
        var hidden = ad > maxVisible;
        var tx = d * step;
        var ry = d === 0 ? 0 : (d < 0 ? ang : -ang);
        var sc = d === 0 ? 1 : Math.max(0.66, 0.86 - (ad - 1) * 0.08);
        var tz = d === 0 ? 0 : -ad * 60;

        card.style.transform = 'translate(calc(-50% + ' + tx + 'px), -50%) rotateY(' + ry + 'deg) translateZ(' + tz + 'px) scale(' + sc + ')';
        card.style.zIndex = String(100 - ad);
        card.style.opacity = hidden ? '0' : '1';
        card.style.pointerEvents = hidden ? 'none' : 'auto';
        card.classList.toggle('is-active', d === 0);
      });

      if (prevBtn) prevBtn.disabled = active === 0;
      if (nextBtn) nextBtn.disabled = active === n - 1;
    }

    function goTo(i) { active = Math.max(0, Math.min(n - 1, i)); layout(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (!autoplay || n <= 1) return;
      stop();
      timer = setInterval(function () { goTo(active >= n - 1 ? 0 : active + 1); }, speed);
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () { if (i !== active) { goTo(i); start(); } });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(active - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(active + 1); start(); });

    var startX = 0;
    vp.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    vp.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { goTo(dx < 0 ? active + 1 : active - 1); }
      start();
    }, { passive: true });

    vp.addEventListener('mouseenter', stop);
    vp.addEventListener('mouseleave', start);
    window.addEventListener('resize', layout);

    layout();
    start();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
  });

})();


  } catch(e) { console.error(e); }
})();
})();
